import { API_URL } from '../../env'
import { logAndReject } from '../../utils/promise'
import { getSiteCountryFromICC2, SiteCountry } from '../models/locale'

export function getCountryByIP(): Promise<SiteCountry> {
  return fetch(`${API_URL}/ip-redirect/`)
    .then(response => response.json())
    .then(data => getSiteCountryFromICC2(data.icc2))
    .catch(logAndReject)
}
